<template>
    <div class="section features-section fade-in-section">
        <h2 class="section-title">Built for the HSC</h2>
        <div class="features-grid">
            <!-- Instant Feedback - tall card on the left -->
            <div class="feature-card feature-card--tall">
                <Zap class="icon" :size="80"/>
                <h3>{{ features.instantFeedback.title }}</h3>
                <p>{{ features.instantFeedback.description }}</p>
            </div>

            <!-- Right column cards -->
            <div class="feature-card">
                <NotebookPen class="icon" :size="48"/>
                <h3>{{ features.hscAligned.title }}</h3>
                <p>{{ features.hscAligned.description }}</p>
            </div>

            <div class="feature-card">
                <ChartNoAxesCombined class="icon" :size="48"/>
                <h3>{{ features.analytics.title }}</h3>
                <p>{{ features.analytics.description }}</p>
            </div>

            <div class="feature-card">
                <Target class="icon" :size="48"/>
                <h3>{{ features.examMode.title }}</h3>
                <p>{{ features.examMode.description }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { ChartNoAxesCombined, NotebookPen, Zap, Target } from 'lucide-vue-next';

export default {
    name: 'FeaturesSection',
    components: {
        NotebookPen,
        ChartNoAxesCombined,
        Zap,
        Target
    },
    data() {
        return {
            features: {
                instantFeedback: {
                    title: 'Instant Feedback',
                    description: 'See exactly where you went wrong and why. No more waiting days for marking'
                },
                hscAligned: {
                    title: 'HSC-Aligned Content',
                    description: 'Every question is tagged with its exact syllabus dot points'
                },
                analytics: {
                    title: 'Detailed Analytics',
                    description: 'Target your weakest topics to avoid surprises on exam day'
                },
                examMode: {
                    title: 'Exam Mode',
                    description: 'Simulate real exam conditions to practice performing under pressure'
                }
            }
        };
    }
};
</script>

<style scoped>
.icon {
    color: var(--text-primary);
    margin-bottom: 15px;
}

.section {
    position: relative;
    z-index: 2;
    padding: 80px 20px;
    max-width: 80vw;
    margin: 0 auto;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-bottom: 1px solid var(--accent);
}

.section-title {
    font-size: 48px;
    text-align: center;
    margin-bottom: 60px;
    color: var(--text-primary);
}

.features-section {
    background: transparent;
}

.features-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(3, 1fr);
    gap: 20px;
}

.feature-card--tall {
    grid-row: span 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.feature-card {
    background: rgba(var(--bg-secondary-rgb), 0.95);
    padding: 40px 30px;
    text-align: center;
    border: 1px solid rgba(var(--accent-rgb), 0.4);
    transition: transform 0.3s, border-color 0.3s;
    position: relative;
    z-index: 5;
}

.feature-card:hover {
    transform: translateY(-5px);
    border-color: var(--accent);
}

.feature-icon {
    font-size: 48px;
    margin-bottom: 20px;
}

.feature-card h3 {
    font-size: 24px;
    color: var(--text-secondary);
    margin-bottom: 15px;
}

.feature-card p {
    font-size: 16px;
    color: var(--text-primary);
    opacity: 0.8;
    line-height: 1.6;
}

.fade-in-section {
    opacity: 0;
    transform: translateY(30px);
    transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.fade-in-section.is-visible {
    opacity: 1;
    transform: translateY(0);
}

@media (max-width: 768px) {
    .section-title {
        font-size: 36px;
    }

    .section {
        min-height: auto;
        padding: 60px 20px;
    }

    .features-grid {
        grid-template-columns: 1fr;
        grid-template-rows: auto;
    }

    .feature-card--tall {
        grid-row: span 1;
    }
}
</style>